import {
  assessment_cards,
  assessment_rows,
  create_empty_declaration_form,
  declaration_cards,
  declaration_rating_options,
  declaration_status_options,
  declaration_type_options,
  recusal_cards,
  recusal_rows,
  register_cards,
  register_rows,
  restriction_rows,
  tabs
} from './conflicts_data';
import { conflict_methods } from './conflicts_helper';
import { drawer_computed, drawer_methods } from './conflicts_drawer';

export default {
  name: 'ComplyonConflictsOfInterest',
  data: () => ({
    tabs,
    active_tab: 'register',
    active_declaration_drawer_ref: null,
    active_declaration_drawer_source: 'register',
    active_declaration_drawer_row_key: null,
    show_new_declaration_modal: false,
    new_declaration_error: '',
    new_declaration_form: create_empty_declaration_form(),
    declaration_type_options,
    declaration_rating_options,
    declaration_status_options,
    register_cards,
    register_rows,
    declaration_cards,
    assessment_cards,
    assessment_rows,
    recusal_cards,
    recusal_rows,
    restriction_rows
  }),
  computed: {
    ...drawer_computed
  },
  methods: {
    ...conflict_methods,
    ...drawer_methods
  }
};
